import deepCopyArray from './deepCopyArray';
import deepCopyObject from './deepCopyObject';
import type { TypeDeepCopyConfig } from './types';

// ----------------------------------------------------------------------------

function deepCopy<T extends any[] | Record<string, any>>(any: T, config: TypeDeepCopyConfig = {}): T {
    return (Array.isArray(any) ? deepCopyArray(any, config) : deepCopyObject(any, config)) as T;
}

// ----------------------------------------------------------------------------

export default deepCopy;
